import React from 'react';
import Hero from '../components/Hero';
import ServicesOverview from '../components/ServicesOverview';
import Stats from '../components/Stats';
import Projects from '../components/Projects';
import CTABanner from '../components/CTABanner';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <ServicesOverview />
      <Stats />
      <Projects />
      <CTABanner />
      <ContactSection />
    </div>
  );
};

export default Home;